import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import * as actions from "../../store/actions/index";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {

  },
  para:{
     
  }
});

class Footer extends Component {
  state = {
    windowHeight: undefined,
    windowWidth: undefined
  };

  handleResize = () => {
    this.setState({
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth
    })
  } 

  componentWillReceiveProps(props) {
    this.setState({ loginInProgress: props.loginInProgress });
  }
  
  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  render() {
    const {classes} = this.props;
    if (this.state.windowWidth > 1220){
        return (
            <Grid
                style={{
                background: "#99192D",
                color: "white",
                padding:'40px',
                }}
                
                justify="center"
                justifyContent="center"
                alignItems="baseline"
                container
                direction="row"
                spacing={12}
            >
                <Grid  item xs={4} sm={4}>
                    <div style={{ marginLeft:'155px'}}>
                    <Grid item xs={12}>
                        <p className={classes.para} style={{fontWeight:'bolder'}} >{this.context.t("contactUs")}</p>
                    </Grid>
                    <Grid item xs={12}>
                        <p className={classes.para}>{this.context.t("tele")} +852 2877 5882</p> 
                    </Grid>
                    <Grid item xs={12}>
                        <p className={classes.para}>{this.context.t("fax")} +852 3011 5086</p> 
                    </Grid>
                    <br></br>
                    <Grid item xs={12}>
                        <p className={classes.para} style={{fontWeight:'bolder'}} >{this.context.t("generalInquiry")}</p>
                    </Grid>
                    <Grid item xs={12}>
                    <p className={classes.para}>info@hkarbsoc.org.hk</p>
                    </Grid>
                    </div>
                </Grid>
                
                <Grid   item xs={4} sm={4}>
                    <Grid item xs={12}>
                    <div style={{ marginLeft:'155px'}}>
                        <Grid item xs={12}>
                            <p className={classes.para} style={{fontWeight:'bolder'}} >{this.context.t("Address")}</p>
                        </Grid>
                        <Grid item xs={12}>
                        <p className={classes.para}> {this.context.t("officeAddress")} </p>
                        </Grid>
                        <Grid item xs={12}>
                        <p className={classes.para}> {this.context.t("officeAddress2")}</p>
                        </Grid>
                        <Grid item xs={12}>
                        <p className={classes.para}> {this.context.t("officeAddress3")}</p>
                        </Grid>
                        <Grid item xs={12}>
                        <br></br>
                        </Grid>
                        </div>
                    </Grid>
                </Grid>
                
                <Grid item xs={4} sm={4}>
                <div style={{ marginLeft:'155px'}}>
                    <Grid>
                        <p className={classes.para} style={{fontWeight:'bolder'}} >{this.context.t("officeHour")}</p>
                    </Grid>
                    {this.props.lang == 'cn' && <Grid item xs={12}>
                        <p className={classes.para}>{this.context.t("monToFri")}</p>
                    </Grid>}
                    {this.props.lang == 'cn' && <Grid item xs={12}>
                        <p className={classes.para}>{this.context.t("morningTime")}</p>
                    </Grid>}
                    {this.props.lang == 'cn' && <Grid item xs={12}>
                        <p className={classes.para}> {this.context.t("afternoonTime")}</p>
                    </Grid>}
                    {this.props.lang == 'cn' && <Grid item xs={12}>
                        <p className={classes.para}>{this.context.t("holidays")}</p>
                    </Grid>}

                    {this.props.lang == 'en' && <Grid item xs={12}>
                        <p className={classes.para}>{this.context.t("monToFri")}
                        {this.context.t("morningTime")} 
                        {this.context.t("afternoonTime")}
                        </p>
                    </Grid>}

                    {this.props.lang == 'en' && <Grid item xs={12}>
                        <p className={classes.para}>
                        {this.context.t("holidays")}
                        </p>
                    </Grid>}
                    </div>
                </Grid>
            </Grid>
        );
    }
    else{
        return (
            <Grid
                style={{
                background: "#99192D",
                color: "white",
                padding:'40px'
                }}
                justify="center"
                justifyContent="center"
                alignItems="flex-start"
                container
                direction="column"
                spacing={12}
            >
                <Grid  item xs={12} sm={12}>
                    <Grid item xs={12}>
                        <p className={classes.para} style={{fontWeight:'bolder'}} >{this.context.t("contactUs")}</p>
                    </Grid>
                    <Grid item xs={12}>
                        <p className={classes.para}>{this.context.t("tele")}</p> +852 2877 5882
                    </Grid>
                    <Grid item xs={12}>
                        <p className={classes.para}>{this.context.t("fax")}</p> +852 3011 5086
                    </Grid>
                    <br></br>
                    <Grid item xs={12}>
                        <p className={classes.para} style={{fontWeight:'bolder'}} >{this.context.t("generalInquiry")}</p>
                    </Grid>
                    <Grid item xs={6}>
                        info@hkarbsoc.org.hk
                    </Grid>
                    <br></br>
                </Grid>
                
                <Grid   item xs={12} sm={12}>
                    <Grid item xs={12}>
                        <Grid item xs={12}>
                            <p className={classes.para} style={{fontWeight:'bolder'}} >{this.context.t("Address")}</p>
                        </Grid>
                        <Grid item xs={12}>
                            {this.context.t("officeAddress")}
                        </Grid>
                        <Grid item xs={12}>
                            {this.context.t("officeAddress2")}
                        </Grid>
                        <Grid item xs={12}>
                            {this.context.t("officeAddress3")}
                        </Grid>
                        <Grid item xs={12}>
                        <br></br>
                        
                        </Grid>
                    </Grid>
                </Grid>
                
                <Grid   item xs={12} sm={12}>
                    <Grid>
                        <p className={classes.para} style={{fontWeight:'bolder'}} >{this.context.t("officeHour")}</p>
                    </Grid>
                    {this.props.lang == 'cn' && <Grid item xs={12}>
                        <p className={classes.para}>{this.context.t("monToFri")}</p>
                    </Grid>}
                    {this.props.lang == 'cn' && <Grid item xs={12}>
                        <p className={classes.para}>{this.context.t("morningTime")}</p>
                    </Grid>}
                    {this.props.lang == 'cn' && <Grid item xs={12}>
                        <p className={classes.para}> {this.context.t("afternoonTime")}</p>
                    </Grid>}
                    {this.props.lang == 'cn' && <Grid item xs={12}>
                        <p className={classes.para}>{this.context.t("holidays")}</p>
                    </Grid>}
    
                    {this.props.lang == 'en' && <Grid item xs={12}>
                        <p className={classes.para}>{this.context.t("monToFri")}
                        {this.context.t("morningTime")} 
                        {this.context.t("afternoonTime")}
                        </p>
                    </Grid>}
    
                    {this.props.lang == 'en' && <Grid item xs={12}>
                        <p className={classes.para}>
                        {this.context.t("holidays")}
                        </p>
                    </Grid>}
                </Grid>
            </Grid>
            );
    }
  }
}

Footer.contextTypes = {
  t: PropTypes.func,
};

const mapStateToProps = (state) => {
  console.log(state);
  return {
    loginInProgress: state.auth.loginInProgress,
    isAuthenticated: state.auth.token !== null,
    error: state.auth.error,
    authRedirect: state.auth.authRedirect,
    newAccount: state.auth.newAccount,
    lang: state.i18nState.lang,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAuth: (username, password) => dispatch(actions.auth(username, password)),
    onSetRedirectPath: (path) => dispatch(actions.setAuthRedirect(path)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Footer))
);
